import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #042E4B 0%, #0A4A6F 100%);
  padding: 4rem;
`;

const Title = styled(motion.h1)`
  font-size: 4.5rem;
  font-weight: 700;
  color: white;
  margin-bottom: 4rem;
  text-align: center;
`;

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3rem;
  max-width: 1400px;
  width: 100%;
`;

const StatCard = styled(motion.div)`
  background: white;
  border-radius: 20px;
  padding: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  box-shadow: 0 10px 40px rgba(0,0,0,0.2);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 8px;
    background: #EF443C;
  }
`;

const StatIcon = styled.div`
  font-size: 4rem;
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #EF443C, #C43931);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(239, 68, 60, 0.3);
`;

const StatNumber = styled.div`
  font-size: 4.5rem;
  font-weight: 900;
  color: #EF443C;
  line-height: 1;
`;

const StatText = styled.div`
  font-size: 1.4rem;
  color: #042E4B;
  text-align: center;
  font-weight: 600;
  line-height: 1.4;
`;

const StatSource = styled.div`
  font-size: 1rem;
  color: #607C90;
  font-style: italic;
  margin-top: 0.5rem;
`;

const Slide5Dados: React.FC = () => {
  const stats = [
    {
      icon: '📊',
      number: '76%',
      text: 'PMEs sem metas desdobradas',
      source: 'Infomoney',
    },
    {
      icon: '📋',
      number: '🚫',
      text: 'Maioria sem planejamento formal',
      source: 'Sebrae',
    },
    {
      icon: '🎯',
      number: '✓',
      text: 'Indicadores = Sucesso',
      source: 'PUC-SP',
    },
  ];

  return (
    <Container>
      <Title
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        O Mercado Confirma
      </Title>

      <CardsContainer>
        {stats.map((stat, index) => (
          <StatCard
            key={`stat-${index}`}
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              duration: 0.4,
              delay: 0.15 + index * 0.1,
              type: 'spring',
              stiffness: 80,
            }}
          >
            <StatIcon>{stat.icon}</StatIcon>
            <StatNumber>{stat.number}</StatNumber>
            <StatText>
              {stat.text}
              <StatSource>{stat.source}</StatSource>
            </StatText>
          </StatCard>
        ))}
      </CardsContainer>
    </Container>
  );
};

export default Slide5Dados;
